import httpService from "../../components/service";
import cacheService from "@/services/cache";

export const details = {
    namespaced: true,
    state: {
        order: null,
        shippingMethods: []
    },
    getters: {
        getOrder: state => state.order,
        shippingMethods: state => state.shippingMethods
    },
    mutations: {
        SET_ORDER(state, order) {
            state.order = order;
        },
        SET_SHIPPING_METHODS(state, shippingMethods) {
            state.shippingMethods = shippingMethods;
        }
    },
    actions: {
        async fetchOrder(context, data) {
            const res = await httpService.getWithCustomInfo("/orders/" + data.orderId, null, data.infos);
            if (res.code) throw res;
            context.commit("SET_ORDER", res);
            return res;
        },
        async editShippingInfos(context, shippingInfos) {
            if (context.state.order.id) {
                const res = await httpService.put("/orders/" + context.state.order.id + "/shipping_cost", JSON.stringify(shippingInfos));
                if (res.code) throw new Error(res.message);
                context.commit("SET_ORDER", res);
                return res;
            }
        },
        async validateFinalPrice(context) {
            let lang = { languageCode: cacheService.getUserLang() };
            if (context.state.order.id) {
                const res = await httpService.put("/orders/" + context.state.order.id + "/validate", JSON.stringify(lang));
                if (res.code) throw new Error(res.message);
                context.commit("SET_ORDER", res);
                return res;
            }
        },
        async addPurchaseOrder(context, data) {
            if (context.state.order.id) {
                const res = await httpService.put("/orders/" + context.state.order.id + "/purchase-order", JSON.stringify(data));
                if (res.code) throw new Error(res.message);
                context.commit("SET_ORDER", res);
                return res;
            }
        },
        async shipOrder(context, data) {
            if (context.state.order.id) {
                const res = await httpService.put("/orders/" + context.state.order.id + "/ship", JSON.stringify(data));
                if (res.code) throw new Error(res.message);
                context.commit("SET_ORDER", res);
                return res;
            }
        },
        async getShippingMethods(context) {
            const res = await httpService.get("/orders/shipping_methods_by_brand");
            if (res.code) throw res;
            context.commit("SET_SHIPPING_METHODS", res);
            return res;
        },
        async sendMessage(context, objMessage) {
            if (context.state.order.id) {
                const res = await httpService.post("/orders/" + context.state.order.id + "/message", JSON.stringify(objMessage));
                context.commit("SET_ORDER", res);
                return res;
            }
        },
        async addDeliveryAddress(context, data) {
            if (context.state.order.id) {
                const res = await httpService.put("/orders/" + context.state.order.id + "/address", JSON.stringify(data));
                if (res.code) throw new Error(res.message);
                context.commit("SET_ORDER", res);
                return res;
            }
        },
        async linkOrderWindow(context, data) {
            if (context.state.order.id) {
                const res = await httpService.put("/orders/" + context.state.order.id + "/countdown", JSON.stringify(data));
                if (res.code) throw new Error(res.message);
                context.commit("SET_ORDER", res);
                return res;
            }
        },
        async deleteOrderAction(context) {
            if (context.state.order.id) {
                const res = await httpService.delete("/orders/" + context.state.order.id + "/delete");
                if (res.code) throw new Error(res.message);
                context.commit("SET_ORDER", res);
                return res;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/orders/details.js